export var breadcrumbStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'inline-flex',
      alignItems: 'center'
    }, p.size === 'smaller' && {
      fontSize: v.fontSizeSmaller
    }, p.size === 'small' && {
      fontSize: v.fontSizeSmall
    }, p.size === 'medium' && {
      fontSize: v.fontSizeMedium
    }, p.size === 'large' && {
      fontSize: v.fontSizeLarge
    });
  }
};
//# sourceMappingURL=breadcrumbStyles.js.map
